import React, { useState } from "react";
import {
  Grid,
  TextField,
  Button,
  Typography,
  Divider,
  Paper,
  Box,
} from "@mui/material";
import { requestDemo } from "../../ApiService/ApiService";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

// Images
import SideDesign from "../../static/SideDesign.png";
// Components
import Footer from "../../Components/Footer";
import Navbar from "../../Components/Navbar";
// Utils
import { isValidEmail, isValidPhoneNumber } from "../../Utils/validFormDetails";

function RequestDemo() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    city: "",
    state: "",
  });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (
      !formData.name ||
      !formData.email ||
      !formData.phone ||
      !formData.city ||
      !formData.state
    ) {
      toast.error("Please fill in all the details.");
      return;
    }
    if (!isValidEmail(formData.email)) {
      toast.error("Please enter a valid email");
      return;
    }
    if (!isValidPhoneNumber(formData.number)) {
      toast.error("Please enter a valid 10-digit phone number");
      return;
    }
    setLoading(true);
    try {
      const response = await requestDemo(formData);
      const status = response.data.status;
      //console.log("response is ", status);
      if (status === 200) {
        toast.success("Demo request sent successful");
        setFormData({
          name: "",
          email: "",
          phone: "",
          city: "",
          state: "",
        });
        // navigate("/home");
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error while sending demo request", error.response.data);
      toast.error("Demo request Failed. Please try agian later");
    }
  };

  return (
    <>
      <ToastContainer />

      <Paper
        sx={{
          height: "100vh",
          display: "flex",
          flexDirection: "column",
          backgroundColor: "#e5e5e5",
        }}
      >
        <Navbar />
        <Paper
          sx={{
            flexGrow: 1,
            p: 3,
            mx: "auto",
            width: "75%",
            boxShadow: "0px 4px 100px rgba(0, 0, 0, 0.1)",
            overflowY: "auto",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <Grid container spacing={2}>
            <Grid
              item
              md={4}
              lg={6}
              xl={6}
              container
              direction="column"
              justifyContent="center"
              sx={{ pr: 3 }}
            >
              <Paper
                elevation={3}
                sx={{
                  padding: 5,
                  boxShadow: "0px 4px 80px rgba(0, 0, 0, 0.1)",
                  ml: 5,
                }}
              >
                <form onSubmit={handleSubmit} style={{ display: "block" }}>
                  <Typography
                    variant="h5"
                    sx={{
                      fontWeight: "bold",
                      textAlign: "center",
                    }}
                  >
                    Request Demo
                  </Typography>
                  <Divider sx={{ p: 1 }} />
                  <Typography
                    variant="h6"
                    sx={{ color: "gray", textAlign: "center" }}
                  >
                    Welcome to{" "}
                    <span
                      style={{
                        color: "black",
                        fontWeight: "bold",
                        fontSize: "18px",
                      }}
                    >
                      SchoolMidas
                    </span>
                  </Typography>

                  <TextField
                    variant="outlined"
                    margin="normal"
                    fullWidth
                    label="Name"
                    name="name"
                    placeholder="Eg. Krishan Kumar"
                    value={formData.name}
                    onChange={handleChange}
                    size="small"
                    required
                  />
                  <TextField
                    variant="outlined"
                    margin="normal"
                    fullWidth
                    label="Email"
                    name="email"
                    placeholder="Eg. john@gmail.com"
                    value={formData.email}
                    onChange={handleChange}
                    size="small"
                    required
                  />
                  <TextField
                    variant="outlined"
                    margin="normal"
                    fullWidth
                    label="Phone"
                    type="text"
                    name="phone"
                    placeholder="Eg. 95xxxxxx44"
                    value={formData.phone}
                    onChange={handleChange}
                    size="small"
                    required
                  />

                  <TextField
                    variant="outlined"
                    margin="normal"
                    fullWidth
                    label="City"
                    type="text"
                    name="city"
                    placeholder="Eg. Noida"
                    value={formData.city}
                    onChange={handleChange}
                    size="small"
                    required
                  />

                  <TextField
                    variant="outlined"
                    margin="normal"
                    fullWidth
                    label="State"
                    type="text"
                    name="state"
                    placeholder="Eg. UP"
                    value={formData.state}
                    onChange={handleChange}
                    size="small"
                    required
                  />
                  <Box sx={{ display: "flex", justifyContent: "space-around" }}>
                    {" "}
                    <Button
                      fullWidth
                      type="submit"
                      variant="contained"
                      color="primary"
                      disabled={loading}
                      endIcon={<ArrowForwardIcon />}
                      sx={{ mt: 3, ml: 1, textTransform: "unset" }}
                    >
                      {loading ? "Loading..." : "Submit"}
                    </Button>
                  </Box>
                </form>
              </Paper>
            </Grid>

            <Grid
              item
              container
              direction="column"
              justifyContent="center"
              alignItems="center"
              md={6}
              lg={6}
              xl={6}
              sx={{
                display: {
                  xs: "none",
                  sm: "none",
                  md: "flex",
                  lg: "flex",
                  xl: "flex",
                },
              }}
            >
              <img
                src={SideDesign}
                alt="background"
                style={{ width: "500px", height: "auto" }}
              />
            </Grid>
          </Grid>
        </Paper>
        <Footer />
      </Paper>
    </>
  );
}

export default RequestDemo;
